export enum MenopauseStage {
  Regular = 'Regular',
  Irregular = "Irregular but haven't stopped",
  PastYear = 'Stopped within the past year',
  YearAgo = 'Stopped over a year ago',
}

export enum MenopauseType {
  Post = 'postmenopausal',
  Peri = 'perimenopausal',
  Meno = 'menopausal',
  Regular = 'regular',
}
